import qs from "qs";

// Report Type Support
const ReportTypes = ['earn', 'transfer-home']

export class Tokenx {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/tokenx`;
  }

  async send(params) {
    const url = `${this.baseURL}/send`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getOrganizationWalletAdminCanTransferList() {
    const url = `${this.baseURL}/organization/wallet/admin`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }

  async getMNCReport (params, type) {
    // Validate Report Type
    if (!ReportTypes.includes(type)) return null

    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/report/mnc/${type}${query}`;
    const response = await this.httpClient.request("get", url);
    return response;
  }

  async getUniqueDataFromReport(fieldName) {
    // Validate fieldName
    if (!fieldName) throw new Error('Invalid field name.')

    // Set URL
    const url = `${this.baseURL}/report/unique/${fieldName}`;

    // Get data from API
    const response = await this.httpClient.request("get", url);
    return response;
  }

  async updateEarnReportData (data) {
    const url = `${this.baseURL}/report`;
    const response = await this.httpClient.request("put", url, { data });
    return response;
  }

  async downloadEarnMNCReport(params, type) {
    // Validate Report Type
    if (!ReportTypes.includes(type)) return null

    const query = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/report/mnc/${type}/download${query}`;
    const config = {
      headers: {
        Accept: "application/octet-stream",
      },
      responseType: "blob"
    }
    const response = await this.httpClient.request("get", url, config);
    return response;
  }

  async getAllEarnCampaignList() {
    const url = `${this.baseURL}/all-earn-campaigns`;

    const response = await this.httpClient.request("get", url);

    return response.data.result;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/tokenx.js